<template>
  <VApp>
    <div class="panel">
      <VLayout
        column
        justify-center
        align-center
      >
        <VFlex xs12>
          <blockquote class="mb-5">
            <h1>
              Welcome to Sndle
            </h1>
            <footer>
              <small>
                <em>&mdash;An innovative way to network</em>
              </small>
            </footer>
          </blockquote>
        </VFlex>
        <VLayout
          align-center
          justify-center
          row
        >
          <VBtn
            color="success"
            @click.prevent="handleLogin"
          >
            Login
          </VBtn>
          <VBtn
            color="primary"
            @click.prevent="handleRegistration"
          >
            Register
          </VBtn>
        </VLayout>
      </VLayout>
    </div>
    <VFooter
      dark
      height="auto"
      absolute
      fixed
      bottom
    >
      <VLayout
        justify-center
        row
        wrap
      >
        <VFlex
          text-xs-center
        >
          <VBtn
            color="white"
            flat
            round
            small
            @click.prevent="tosDialog = true"
          >
            <div
              class="caption"
            >
              Terms of Service
            </div>
          </VBtn>
          &nbsp;•&nbsp;
          <VBtn
            color="white"
            flat
            round
            small
            @click.prevent="privacyDialog = true"
          >
            <div
              class="caption"
            >
              Privacy Policy
            </div>
          </VBtn>
        </VFlex>
      </VLayout>
    </VFooter>
    <OverflowedTextDialogCard
      v-if="tosDialog"
      card-title="Terms of Service"
      :card-text="tosText"
      :dialog.sync="tosDialog"
    />
    <OverflowedTextDialogCard
      v-if="privacyDialog"
      card-title="Privacy Policy"
      :card-text="privacyText"
      :dialog.sync="privacyDialog"
    />
    <ParticlesJS
      class="particles"
    />
  </VApp>
</template>

<script>
import ParticlesJS from '@/components/ParticlesJS'
import OverflowedTextDialogCard from '@/components/OverflowedTextDialogCard'
import tos from '@/assets/tos.json'
import privacy from '@/assets/privacy.json'
export default {
  name: 'HomePage',
  components: { ParticlesJS, OverflowedTextDialogCard },
  data: function () {
    return {
      tosDialog: false,
      privacyDialog: false,
      tosText: tos.text,
      privacyText: privacy.text
    }
  },
  methods: {
    handleLogin () {
      this.$router.push({ name: 'login' })
    },
    handleRegistration () {
      this.$router.push({ name: 'phone-verification-request' })
    }
  }
}
</script>
<style lang="scss" scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.particles {
  background-color: black;
  width: 100%;
  height: 100%;
}
.panel {
  display: block;
  font-family: 'Source Sans Pro';
  font-size: 1.3em;
  position: absolute;
  width: 280px;
  height: 200px;
  background: #d2d2d2;
  top: 50%;
  left: 50%;
  margin:-100px 0 0 -140px;
  padding: 20px;
  border-radius: 4px;
  box-sizing: border-box;
  z-index:100;
  h1 {
    font-size: 1.4em;
    font-weight: 700;
    text-align: center;
    color: #222;
    margin-top: -4px;
  }
}
</style>
